import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useRetainedValue } from '@sorare/core/src/hooks/useRetainedValue.ts';
import { BuyConfirmationDialog } from '@sorare/marketplace/src/components/buyActions/BuyConfirmationDialog';
import { BuyTokenConfirmation } from '@sorare/marketplace/src/components/buyActions/BuyTokenConfirmation';

import type { CardConfirmedDialog_anyCardInterface } from './__generated__/index.graphql.ts';

type Props = {
  open: boolean;
  onClose: () => void;
  card: CardConfirmedDialog_anyCardInterface | null | undefined;
};

export const CardConfirmedDialog = ({ open, onClose, card }: Props) => {
  const retainedCard = useRetainedValue(card);

  return (
    <BuyConfirmationDialog open={open} onClose={onClose}>
      {!!retainedCard && (
        <BuyTokenConfirmation card={retainedCard} onClose={onClose} />
      )}
    </BuyConfirmationDialog>
  );
};

CardConfirmedDialog.fragments = {
  anyCardInterface: gql`
    fragment CardConfirmedDialog_anyCardInterface on AnyCardInterface {
      slug
      ...BuyTokenConfirmation_anyCard
    }
    ${BuyTokenConfirmation.fragments.anyCard}
  ` as TypedDocumentNode<CardConfirmedDialog_anyCardInterface>,
};
